import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * Slot recipe for the flyout's tool navigation — the row of secondary links and
 * the country selector that closes the navigation panel (STOK-17026 §5).
 *
 * The row itself is viewport-agnostic: links pinned to the start, country
 * selector to the end, on both viewports. Only the two controls change size
 * across the breakpoint, and they do that through their own recipe variants
 * (`size` on `Button`), not here — see `flyout-navigation.recipe.js` for where
 * the row is placed within the panel.
 */
export const flyoutToolNavRecipe = defineSlotRecipe({
    className: 'flyout-tool-nav',
    slots: ['root', 'links'],
    base: {
        root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 'spacing-16'
        },
        links: {
            display: 'flex',
            alignItems: 'center',
            // Desktop hands the row `pointer-events: none` so its empty middle
            // does not swallow clicks on the navigation content beneath (see
            // `toolNavContainer` in `flyout-navigation.recipe.js`); the controls
            // opt back in here, where they can be named directly rather than
            // matched by tag from the placement slot.
            pointerEvents: 'auto',
            // WCAG 2.5.8: the labels are only 20px tall, so they clear the
            // 24px target minimum by the spacing exception — this gap is what
            // keeps their target circles from intersecting. Not decoration.
            gap: 'spacing-24'
        }
    }
})
